/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { CarbonDetailSiteField } from '../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { convertDataForCarbonUtilitySavingsSite } from '../../../shared/Utils/CarbonViewDetailsUtils';
import CarbonDetailTabBreakdownBySite from '../../../shared/DetailBreakdownByMeter/CarbonDetailTabBreakdownBySite';
import { ICarbonScopeOneSavingsByMeterDetailComponentProps } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import './PortfolioCarbonScopeOneSavingsBySiteDetail.scss';
import { ApiContext } from '../../../../context/ApiContext';

export const PortfolioCarbonScopeOneSavingsByMeterDetailComponent = (
  props: ICarbonScopeOneSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const {
    data: { emissionMeasurementUnit, breakdownBySite }
  } = props;

  const apiContext = useContext(ApiContext);

  const meterSavingdata = convertDataForCarbonUtilitySavingsSite(
    breakdownBySite,
    emissionMeasurementUnit,
    apiContext.showChangeWhenData
  );

  const { values, displayUnit } = meterSavingdata;

  const columnDetails: IDataTableColumn[] = [
    {
      className: 'datatable-column-meter',
      field: CarbonDetailSiteField.site,
      header: t(d.SITES),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonDetailSiteField.actualConsumption,
      header: t(d.PORTFOLIOACTUALEMISSION),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonDetailSiteField.baselineConsumption,
      header: t(d.PORTFOLIOPREVIOUSEMISSION),
      sortable: true,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonDetailSiteField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '9%'
    }
  ];
  return (
    <div className="emaas-Metersaving-details-head">
      <CarbonDetailTabBreakdownBySite
        meterData={values}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        emissionMeasurementUnit={emissionMeasurementUnit}
      />
    </div>
  );
};
export default PortfolioCarbonScopeOneSavingsByMeterDetailComponent;
